export const aciInternetAdditionalCharges = {
    iconName: 'internet-additional-charges',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M9.965 15.604c.54-.54 1.271-.842 2.034-.842a.5.5 0 010 1 1.876 1.876 0 000 3.752.5.5 0 010 1 2.876 2.876 0 01-2.034-4.91zM7.443 13.085a6.44 6.44 0 018.262-.712.5.5 0 11-.576.818 5.44 5.44 0 00-6.979.601.5.5 0 11-.707-.707z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M4.926 10.563a10.005 10.005 0 0114.148 0 .5.5 0 01-.707.707 9.005 9.005 0 00-12.734 0 .5.5 0 01-.707-.707z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M2.749 7.713a13.569 13.569 0 0118.503 0 .5.5 0 01-.682.732 12.569 12.569 0 00-17.14 0 .5.5 0 11-.681-.732zM15.621 15.71c.236-.194.533-.3.839-.3h1.235a.5.5 0 110 1H16.46a.318.318 0 00-.31.256.316.316 0 00.192.353l1.256.502a1.316 1.316 0 01-.49 2.537H15.87a.5.5 0 010-1h1.235a.317.317 0 00.118-.609l-1.254-.501a1.316 1.316 0 01-.349-2.237z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M16.787 14.953a.5.5 0 01.5.5v.456a.5.5 0 11-1 0v-.456a.5.5 0 01.5-.5zM16.787 19.059a.5.5 0 01.5.5v.456a.5.5 0 11-1 0v-.456a.5.5 0 01.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M13.854 14.8a4.148 4.148 0 115.865 5.866 4.148 4.148 0 01-5.866-5.865zm2.932-.214a3.148 3.148 0 100 6.296 3.148 3.148 0 000-6.296z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
